import moment from 'moment';
import React from 'react';
import { DATE_ONLY_FORMAT, dateString } from 'researcher/helpers/date';
import { T, useTranslate } from 'shared/helper/translate';
var DigitalEditingInstructions = function DigitalEditingInstructions(_ref) {
  var accessType = _ref.accessType,
    digitalEditingPurchase = _ref.digitalEditingPurchase;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "digital-editing-instructions-".concat(accessType),
    params: {
      subscriptionEndsDate: digitalEditingPurchase ? dateString(t, moment(digitalEditingPurchase.endsAt), DATE_ONLY_FORMAT) : ''
    }
  })));
};
export default DigitalEditingInstructions;